import React, { memo, useMemo, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Stack } from '@fluentui/react/lib/Stack'
import { Persona, PersonaSize } from '@fluentui/react/lib/Persona'
import Button, { ButtonType } from '../Button'
import { setAppReady, setGlobalLoader, appDestroy } from '../../actions/views'
import { clearCache } from '../../apis'
import { getUDC } from '../../actions/udc'

export default memo(({ user, fullMode, setFullMode }) => {
    if (!user) return null

    const dispatch = useDispatch()
    const reload = useCallback(() => {
       
        dispatch(appDestroy())
        dispatch(setAppReady(false))
        dispatch(setGlobalLoader(true))
        clearCache().then(() => {
            dispatch(getUDC())
            dispatch(setAppReady(true))
            dispatch(setGlobalLoader(false))
        })

        //try {
        //    dispatch(clearAllDataIndexedDB())
        //} catch (error) {
        //    console.error('Error clearing IndexedDB:', error)
        //}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])



    const clearAllDataIndexedDB = (() => {
        try {

            let request = indexedDB.open('store');

            request.onsuccess = function (event) {
                let db = event.target.result;
                let transaction = db.transaction(['keyvaluepairs'], 'readwrite');
                let objectStore = transaction.objectStore('keyvaluepairs');

                // Clear all data from the object store
                let clearRequest = objectStore.clear();

                clearRequest.onsuccess = function (event) {
                    console.log('Object store cleared successfully');
                };

                clearRequest.onerror = function (event) {
                    console.error('Error clearing object store:', event.target.error);
                };

                transaction.oncomplete = function (event) {
                    console.log('Transaction completed');
                };

                transaction.onerror = function (event) {
                    console.error('Transaction error:', event.target.error);
                };



            }

            request.onerror = function (event) {
                console.log('Error clearing open indexedDB');
            };

            console.log('ABC function called');
        }
        catch (error) {

        }
    });

    const menus = useMemo(() => [{
        key: '0',
        text: `full screen: ${fullMode ? 'on' : 'off'}`,
        iconProps: { iconName: fullMode ? 'CheckboxCompositeReversed' : 'Checkbox' },
        onClick: () => setFullMode(!fullMode),
    }, {
        key: '1',
        text: 'invalidate cache and refresh',
        iconProps: { iconName: 'Refresh' },
        onClick: reload,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }], [fullMode])

    useEffect(() => {
        dispatch(getUDC())
    }, [])
    const udc = useSelector(state => state.udc)

    return (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }} styles={{ root: { marginBottom: 8 } }}>
            <Stack.Item grow>
                {udc.list ? (
                    <div style={{ fontWeight: "normal", fontFamily: "sans-serif", fontSize: "16px" }}>
                        <span style={{ fontWeight: "normal" }}>2026 Thailand Asset UDC Target ($/BOE): </span>
                        <span style={{ fontWeight: "800", marginLeft: "5px" }}>{udc.list.tbuTarget}</span>
                        <span style={{ marginLeft: "10px", fontWeight: "normal" }}>YEE: </span>
                        <span style={{
                            fontWeight: "800",
                            color: udc.list.gotyee <= udc.list.tbuTarget ? "green" : "red",
                            marginLeft: "5px"
                        }}>
                            {udc.list.gotyee.toFixed(2)}
                        </span>
                    </div>
                ) : (
                    <div>Loading UDC data...</div>
                )}
            </Stack.Item>
            <Persona imageInitials={user.cai.slice(0, 2)} text={user.displayName} title={`${user.displayName} [${user.unique}]`} size={PersonaSize.size24} />
            <Button
                type={ButtonType.icon}
                menuProps={{
                    items: menus
                }}
            />
        </Stack>
    )
})

